<template>
  <v-card class="lead-form-mobile">
    <v-card-text class="pa-0 close-button-wrapper">
      <v-btn icon @click="$emit('close')">
        <v-icon color="#3A3A3A">mdi-close</v-icon>
      </v-btn>
    </v-card-text>

    <!-- 메인 컨텐츠 -->
    <v-card-text class="pa-6 main-content">
      <!-- 헤더 -->
      <div class="header-section mb-6">
        <h2 class="title">매출 올리는 방법,<br />무료 상담에서 확인하세요!</h2>
        <p class="subtitle mt-4">
          키워드만 제대로 설정해도<br />
          평균 매출이 23% 늘어납니다.
        </p>
      </div>

      <LeadFormTabs :type.sync="localType" class="mb-4" />

      <LeadExperienceHeader :type="formData.type" class="mb-4" />

      <LeadFormContent
        :formData="formData"
        :items="items"
        :showAvailableTime="true"
        @update:formData="handleUpdateFormData"
        @validation="handleValidation" />

      <!-- 제출 버튼 (컨텐츠 내부) -->
      <div class="submit-button-wrapper">
        <v-btn :disabled="!isFormValid" class="submit-button" @click="$emit('submit')" block depressed>
          무료 상담하기
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import LeadFormTabs from './LeadFormTabs.vue';
import LeadExperienceHeader from '../header/LeadExperienceHeader.vue';
import LeadFormContent from './LeadFormContent.vue';

export default {
  name: 'LeadFormMobile',

  components: {
    LeadFormTabs,
    LeadExperienceHeader,
    LeadFormContent,
  },

  props: {
    formData: {
      type: Object,
      required: true,
    },
    isFormValid: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      items: [
        { text: '시간 무관', value: '시간 무관' },
        { text: '10:00 ~ 11:30', value: '10:00-11:30' },
        { text: '14:00 ~ 15:30', value: '14:00-15:30' },
        { text: '15:30 ~ 17:30', value: '15:30-17:30' },
      ],
      isInputFocused: false,
    };
  },

  mounted() {
    this.$el.addEventListener('focusin', this.handleFocusIn);
    this.$el.addEventListener('focusout', this.handleFocusOut);
  },

  beforeDestroy() {
    this.$el.removeEventListener('focusin', this.handleFocusIn);
    this.$el.removeEventListener('focusout', this.handleFocusOut);
  },

  computed: {
    localType: {
      get() {
        return this.formData.type;
      },
      set(value) {
        this.$emit('update:formData', { ...this.formData, type: value });
      },
    },
  },

  methods: {
    handleUpdateFormData(data) {
      this.$emit('update:formData', data);
    },

    handleValidation(isValid) {
      this.$emit('handleFormValid', isValid);
    },

    handleFocusIn(event) {
      const target = event.target;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
        this.isInputFocused = true;
        const buttonWrapper = this.$el.querySelector('.submit-button-wrapper');
        if (buttonWrapper) {
          buttonWrapper.style.paddingBottom = '250px';
        }
      }
    },

    handleFocusOut() {
      this.isInputFocused = false;
      const buttonWrapper = this.$el.querySelector('.submit-button-wrapper');
      if (buttonWrapper) {
        buttonWrapper.style.paddingBottom = '100px';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lead-form-mobile {
  width: 100%;
  max-width: 100%;
  height: 100vh;
  background: #ffffff;
  border-radius: 0 !important;
  box-shadow: none !important;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch; // iOS 부드러운 스크롤
  overscroll-behavior: contain; // 스크롤 바운스 방지 (모달 내부에만 스크롤)
}

/* 메인 컨텐츠 */
.main-content {
  padding-bottom: 24px !important;
}

/* 닫기 버튼 */
.close-button-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px !important;
}

/* 헤더 */
.header-section {
  .title {
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    color: #212121;
  }

  .subtitle {
    font-family: 'Spoqa Han Sans Neo';
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #808080;
  }
}

/* 모바일 전용: 탭 버튼 flex 균등 분배 */
::v-deep .tab-section .tab-btn {
  flex: 1;
}

/* 제출 버튼 래퍼 */
.submit-button-wrapper {
  margin-top: 24px;
  padding-bottom: 100px; // 기본 여백 (포커스 시 JavaScript로 250px로 변경)
}

/* 제출 버튼 */
.submit-button {
  width: 100%;
  height: 42px !important;
  min-height: 42px !important;
  background: #ea2a3a !important;
  border-radius: 8px !important;
  font-family: 'Spoqa Han Sans Neo';
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff !important;
  text-transform: none;
  letter-spacing: 0;
  box-shadow: none !important;

  &:disabled {
    background: #dbdbdb !important;
    color: #ffffff !important;
  }
}
</style>
